// Invoice Address Store
import { getField, updateField } from 'vuex-map-fields'

const state = {
  invoiceAddress: {},
  newsletter: true,
  has_newsletter: false,
  pending: false,
}

const getters = {
  isPending: ({ pending }) => pending,
  getField,
}

const actions = {
  updateAddress({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.createItem('carts.mine.invoice_address', { ...payload, newsletter: state.newsletter }).then(({ data }) => {
        if (data && data.redirect) {
          window.location.href = data.redirect
        } else {
          commit('LAST_UPDATE_ADDRESS')
          commit('SET_PENDING')
          resolve()
        }
      })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_INVOICE_ADDRESS: (state, payload) => {
    state.invoiceAddress = payload
  },
  INIT_INVOICE_ADDRESS: (state, payload) => {
    state.invoiceAddress = payload
  },
  updateField,
  LAST_UPDATE_ADDRESS: _ => {
    return true
  },
  SET_USER_NEWSLETTER: (state, payload) => {
    state.newsletter = payload
  },
  SET_HAS_USER_NEWSLETTER: (state, payload) => {
    state.has_newsletter = payload
    state.newsletter = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
